/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, {useState} from 'react';
import {ReactComponent as ArrowDown} from "../assets/img/icons/arrowDown.svg";
import FilterExpand from "./FilterExpand";

const FilterDouble = (props) => {

    const [open, setOpen] = useState( props.filter.has_selected_part ||false);

    function clickHundler(){
        setOpen(!open);
    }

    return (
        <div className={`filter ${open ? "opened" : ""} ${props.filter.total_parts > 0 ? "" : "zero-match"}  `}>
            <div className='filter__header' onClick={clickHundler}>
                <div className="row align-items-center extra-small-gutters">
                    <div className="col col--icon">
                        <img src={props.filter.image} alt={props.filter.title}/>
                    </div>
                    <div className="col">
                        <span className='filter__label'>{props.filter.title}</span>
                    </div>
                    <div className="col-auto">
                        <span className='filter__num'>{props.filter.total_parts}</span>
                    </div>
                    <div className="col-auto">
                        <span><ArrowDown/></span>
                    </div>
                </div>
                {/*<div className='filter__icon'><img src={props.filter.image} alt={props.filter.title}/> </div>*/}
                {/*<div className='filter__label'>{props.filter.title}</div>*/}
                {/*<div className='filter__num'>{props.filter.total_parts}</div>*/}
                {/*<div className='filter__arrow'><ArrowDown/></div>*/}
            </div>
            <div className='filter__body'>
                { open && props.filter.subcategories.map( (subcategory, index) => (
                    <FilterExpand link={props.link} parts={subcategory.parts} has_selected_part={subcategory.has_selected_part} title={subcategory.part_category_title} key={index}/>
                    ))
                }
            </div>
        </div>
    );
};

export default FilterDouble;
